import { useSceneState, useSceneActions } from '../../presentation/providers/SceneProvider';
import { shouldWarn } from '../../domain/services/CachePolicy';

export function useCache() {
  const { cacheMetrics, prefetchProgress, cache } = useSceneState();
  const { prefetchAll } = useSceneActions();

  return {
    metrics: cacheMetrics,
    loadedFrames: cacheMetrics.loadedFrames,
    warning: shouldWarn(cacheMetrics),
    prefetchProgress,
    prefetchAll,
    getColorBuffer: (frameId: number) => cache.getColorBuffer(frameId),
  };
}
